import type { RequestSource } from "@frontend/lib/schemas/clientSchema";

interface GetCartPriceParams {
  fname: string;
  lname: string;
  dob: string;
  insurances: { memberId: string; payer: string; state: string }[];
  npiId?: string;
  providerLastName?: string;
  orgId?: number;
  hrts: { hrtId: number }[];
  requestSource: RequestSource;
  email: string | null;
  practiceId?: number;
  providerId?: number;
  forceGenerateInsuredPricedTreatments?: boolean;
}

export async function getCartPrice(params: GetCartPriceParams) {
  const response = await fetch("/api/cart/price", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch cart price");
  }

  return response.json();
}
